<div class="astral-stack-l" [formGroup]="form">
  <section class="astral-section-surface">
    <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
      <astral-date-picker [emptyIsNull]="true" [control]="form.controls.vacancyFrom"></astral-date-picker>
      <astral-date-picker [emptyIsNull]="true" [control]="form.controls.vacancyTo"></astral-date-picker>
      <astral-date-picker [emptyIsNull]="true" [control]="form.controls.publishFrom"></astral-date-picker>
      <astral-date-picker [emptyIsNull]="true" [control]="form.controls.publishTo"></astral-date-picker>
    </astral-layout-group>
  </section>

  @if (missingPublishFields.length) {
    <section class="astral-section-surface astral-section-surface--nested astral-stack-s">
      <div>{{ 'LETTING.ADVERTISMENT.BOPLATS_SVERIGE.MISSING_OBJECT_FIELDS' | translate }}</div>
      <ul>
        @for (field of missingPublishFields; track field) {
          <li>{{ field | translate }}</li>
        }
      </ul>
    </section>
  }

  <section class="astral-section-surface astral-form-stack">
    <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
      <app-money-box [control]="form.controls.monthlyRent"></app-money-box>
      <app-money-box [control]="form.controls.yearlyRent"></app-money-box>
      <astral-select
        [control]="form.controls.monthsWithRent"
        [itemsSource]="monthSelection"
        [helpText]="'LEASE_AGREEMENT_ROW.HELP_TEXT.CHARGED_MONTHS'"
        [multiple]="true"
      ></astral-select>
      <astral-input [span]="'full'" [control]="form.controls.boplatsSverigeDescriptionURL"></astral-input>
    </astral-layout-group>
    <astral-textarea [control]="form.controls.boplatsSverigeObjectDescription"></astral-textarea>
    <astral-checkbox [control]="form.controls.uniqueObjectDescription"></astral-checkbox>
  </section>
</div>
